<template>
  <div class="w-100">
  <b-breadcrumb class="w-100" :items="items"></b-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: this.$route.meta.pageTitle,
          href: this.$route.path,
          active:true
        },
      ]
    }
  }
}
</script>